export const APP_CONFIG = {
  name: 'AryanFix Worker Portal',
  tagline: 'Private operations workspace for AryanFix worker staff.',
  emoji: '✦',
  icon: 'LayoutDashboard',
  defaultTheme: 'system',
  defaultLoginRoute: '/worker/login',
};

export const AUTH_PROFILES = [
  {
    key: 'worker',
    name: 'Worker_c',
    label: 'Worker',
    profileSlug: '',
    redirectAfterAuth: '/',
    hasSignup: false,
    reportsTo: 'Admin_c',
    authPage: {
      loginTitle: 'Worker sign in',
      signupTitle: 'Account creation is restricted',
      loginDescription: 'Private workspace for authorized AryanFix worker staff.',
      signupDescription: 'Public registration is disabled. Ask the business owner for an invitation.',
    },
  },
];

export const GENERIC_AUTH = {
  loginTitle: 'Worker sign in',
  signupTitle: 'Account creation is restricted',
  loginDescription: 'Private workspace for authorized AryanFix worker staff.',
  signupDescription: 'Public registration is disabled. Ask the business owner for an invitation.',
  redirectAfterAuth: '/',
};
